import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { useWorkOrdersContext } from "../context/workOrdersContext";
import { cmmsTheme } from "@setup/theme/cmms-theme";

type Props = {};

export const StatusFilter = ({}: Props) => {
	const { state } = useWorkOrdersContext();
	const [searchParams, setSearchParams] = useSearchParams();
	const status = searchParams.get("status") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("status", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box>
			<FormControl
				variant="outlined"
				margin="dense"
				fullWidth>
				<InputLabel id="status-select-label">Status</InputLabel>
				<Select
					labelId="status-select-label"
					id="status-select"
					value={status}
					onChange={handleFilter}
					label="Status"
					style={cmmsTheme.styles.filterSelect}>
					{state.statusCodes.map((status) => {
						return (
							<MenuItem
								style={{ paddingBottom: 0 }}
								key={`logId-${status.id}`}
								value={status.id}>
								{status.description}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
